<template>
    <div class="search-panel">



        <span class="search-field" ref="searchField">
            <svg-icon :symbol="searchIcon.default" :originalDims="true" class="search-field-indicator svg-icon search-field-icon"></svg-icon>
            <!-- optional indicators -->
            <spinner v-if="loading" class="search-field-indicator search-field-spinner"></spinner>
            <template v-else>
                <svg-icon v-show="isDirty" @click="reset" :symbol="cancelIcon.default" :originalDims="false" class="search-field-indicator svg-icon search-field-close"></svg-icon>
            </template>

            <!-- the input field -->
            <input type="text"
                   placeholder="Meklē..."
                   autocomplete="off"
                   v-model="query"
                   @keydown.down="down"
                   @keydown.up="up"
                   @keydown.enter="hit"
                   @keydown.esc="reset"
                   @blur="onBlur"
                   @focus="onFocus"
                   @input="debouncedUpdate"/>
        </span>

        <!-- the list -->
        <ul v-show="hasItems" class="search-result-list">
            <!-- for vue@1.0 use: ($item, item) -->
            <li v-for="(item, $item) in items" :class="activeClass($item)" @mousedown="hit" @mousemove="setActive($item)">
                <svg class="file-icon icon" :class="'icon-' + item.basicType" style="width:70px;height:70px;"><use :xlink:href="'#' + item.basicType"></use></svg>
                <h2>{{ item.title }}</h2>
                <span class="result-description">{{ item.description }}</span>
                <span class="result-type">{{ item.breadcrumb }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
    import VueTypeahead from 'vue-typeahead'
    import SvgIcon from '../components/SvgIcon'
    import materials from '../api/materials'
    import _ from 'lodash'

    export default {
        name: "search",
        extends: VueTypeahead,
        data() {
            return {
                // The source url
                // (required)
                src: '/api/search',

                // The data that would be sent by request
                // (optional)
                data: {},

                // Limit the number of items which is shown at the list
                // (optional)
                limit: 10,

                // The minimum character length needed before triggering
                // (optional)
                minChars: 3,

                // Highlight the first item in the list
                // (optional)
                selectFirst: false,

                // Override the default value (`q`) of query parameter name
                // Use a falsy value for RESTful query
                // (optional)
                queryParamName: 'q',

                // Icons
                searchIcon: require('../../icons/icon-search.svg-sprite'),
                cancelIcon: require('../../icons/icon-cancel.svg-sprite')
            }
        },
        methods: {
            // The callback function which is triggered when the user hits on an item
            // (required)
            onHit(item) {
                // alert(item)
                console.log('onHit', item)
                this.$router.push({ name: 'material', params: { id: item.id } })
            },

            onFocus() {
                this.$el.classList.add('expanded')
            },

            onBlur() {
                this.reset();
                this.$el.classList.remove('expanded')
            },

            // The callback function which is triggered when the response data are received
            // (optional)
            prepareResponseData(data) {
                // data = ...
                data.data.forEach(function (material, index, arr) {

                    if ( material.source_type === 'materials' ) { 
                        material.breadcrumb = material.path.map(function (p) { return p.title; }).join('/');
                        material.description = material.description > 200 ? material.description.substr(0, 200) + '...' : material.description;
                        material.basicType = materials.basicType(material);
                    } else {

                    }
                   
                });

                return data.data
            },

            debouncedUpdate: _.debounce(function () {
                this.update()
            }, 500),
        },
        components: {
            SvgIcon
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    $search-panel-font-size: 1.2rem;

    .search-panel {

        padding: 0;
        margin-left: auto;
        transition: width 0.25s ease-in-out;
        position: relative;

        /* Expandable search-panel in top bar */
        &.expanded {
            width: 100%;
            margin-left: 40px;
        }

        .search-field {
            font-size: $search-panel-font-size;
            position: relative;

            .search-field-indicator {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                z-index: 1;

                fill: $color-light-gray;

                &.search-field-icon {
                    left: 1em;
                    width: 26px;
                    height: 26px;
                }

                &.search-field-close {
                    cursor: pointer;
                    width: 26px;
                    height: 26px;
                }

                &.search-field-close,
                &.search-field-spinner {
                    right: 1em;
                }
            }

            input {
                display: inline-block;
                padding: 0.5rem 0.5rem 0.5rem 2.75em;
                height: auto;
                max-width: none;
                margin-right: 0;
                background-color: $color-concrete-gray;
                border: 2px solid $medium-gray;
                transition: width 0.25s ease-in-out;
                margin-bottom: 0;
                font-size: 20px;

                &::placeholder {
                    color: $dark-gray;
                }

                &:focus,
                &:active {
                    background-color: $white;
                    -webkit-box-shadow: none;
                    -moz-box-shadow: none;
                    box-shadow: none;
                }
            }
        }

        .search-result-list {
            @include reset-list();
            position: absolute;
            z-index: 2;
            background-color: white;
            width: 100%;
            max-height: 500px;
            overflow-y: auto;

            > li {
                padding: rem-calc(10px) rem-calc(10px) rem-calc(10px) rem-calc(95px);
                cursor: pointer;
                transition: background-color 0.15s ease-in;
                min-height: rem-calc(70px + 10px + 10px);

                &:hover,
                &:active {
                    background-color: $color-concrete-gray;
                }

                &:not(:last-child) {
                    border-bottom: 1px solid $color-light-gray;
                }
            }

            h2 {
                margin: 0;
                line-height: 1.2;
            }
            .result-description {
                color: $color-dark-gray;
                display: block;
                line-height: 1.4;
                margin-bottom: 0.2em;
            }

            .result-url,
            .result-type {
                color: gray;
                display: block;
                text-transform: uppercase;
                font-size: rem-calc(9px);
            }

            .icon {
                width: 70px;
                height: 70px;
                position: absolute;
                left: rem-calc(10px);
            }
        }


        .typeahead__container {
            font: inherit;

            &.result {
                opacity: 1;
                font-weight: inherit;
                padding: 0;
                border: none;
                margin: 0;
            }

            &.loading {
                .typeahead__query {
                    &:before, &after {
                        //content: none;
                    }
                }
            }

            strong {
                font-weight: inherit;
                background-color: rgba(255, 255, 0, 0.4);
            }
        }

        .typeahead__field {
            text-align: right;

            &.input-with-icon {
                /*
                 * Better performance for animation
                 */

            }


        }

        .typeahead__list {
            background-color: white;
        }

        .typeahead__cancel-button {
            top: 50%;
            transform: translateY(-50%);
        }

        .typeahead__dropdown,
        .typeahead__list {
            > li {
                > a {
                    padding: rem-calc(10px);
                }
            }
        }
        .typeahead__list {
            max-height: 80vh;
            overflow-y: auto;
            font-size: rem-calc(13px);
        }

        .typeahead__result {
            position: relative;
            padding-left: 85px;
            @include clearfix();

            svg {
                width: 70px;
                height: 70px;
                position: absolute;
                left: 0;
            }

        }

        > form {
            width: 100%;
            margin: auto;

            > a {
                margin-left: 10px;
                width: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/Search.vue